var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "block",
    attrs: {
      loading: _vm.isLazyLoad ? "lazy" : false,
      src: _vm.src,
      srcset: _vm.srcset,
      sizes: _vm.sizes,
      alt: _vm.alt,
      width: Math.ceil(_vm.baseWidth),
      height: Math.ceil(_vm.baseHeight),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }